import { BaseActionObject, StateNodeConfig } from "xstate4"
import { Context, Transitions } from "../../types"
import { baseTransition } from "../transitions"

export const downloadDataState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  ...baseTransition("downloadClassData", "downloadClassData", "idle", {
    loadingState: "download",
    onSuccess: (_ctx, _evt) => ({
      snackbar: {
        message: "Successfully downloaded class information",
        withUndo: false,
        error: false
      }
    }),
    successActions: ["downloadByUrl"],
    onError: (_ctx, _evt) => ({
      snackbar: {
        message:
          "An error occurred. Unable to download class information. Please try again or if the problem persists, contact customer support.",
        withUndo: false,
        error: true
      }
    })
  })
}
